import * as React from 'react';
import { Popover } from '@cian/ui-kit';

import * as styles from './LocationPopover.css';

interface ILocationPopoverProps {
  children: React.ReactElement;
  content: React.ReactNode;
  isOpen: boolean;
}

export const LocationPopover: React.FC<ILocationPopoverProps> = ({ children, content, isOpen }) => {
  return (
    <div className={styles['container']}>
      <Popover placement="bottom" open={isOpen} content={content}>
        {children}
      </Popover>
    </div>
  );
};
